import withFeatureToggling from '../../hocs/withFeatureToggling/withFeatureToggling';

const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
import { withRouter } from 'react-router-dom';
const stepsActions = require('actions/stepsActions');
const preLoaderActions = require('actions/preLoaderActions');
const Storage = require('utilities/storage');
const { ALLOW_COOKIE } = require('constants/index');
import { shouldRedirectToModelOnboarding, goModelOnboarding } from 'utilities/modelOnboardingHelper';
import { MODEL_BANK_REDIRECTION_ONBOARDING } from 'constants/featureFlagging';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { ERROR_AL_RECUPERAR_ONBOARDING } from 'constants/analyticsErrors';

class ContinueOnboardingComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadedData: false,
        };
        this.checkCookie = this.checkCookie.bind(this);
        this.checkToken = this.checkToken.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { pathname } = this.props.location;
        const accessToken = Storage.cookies.get('accessToken');
        const { contractToken } = this.props.match.params;
        const isModelRedirectFlagOn = this.props.flags.get(MODEL_BANK_REDIRECTION_ONBOARDING);

        if (pathname.indexOf('login') !== -1) {
            Storage.cookies.remove('accessToken');
            Storage.cookies.remove('refreshToken');

            return;
        }

        if (shouldRedirectToModelOnboarding(accessToken, contractToken) && isModelRedirectFlagOn) {
            return goModelOnboarding();
        }

        if (!this.state.loadedData) {
            if (ALLOW_COOKIE && accessToken) {
                this.checkCookie();
            }

            if (!this.state.loadedData && contractToken) {
                this.checkToken();
            }
        }
    }

    checkCookie() {
        this.props.preLoaderActions.showPreLoader();
        const accessToken = Storage.cookies.get('accessToken');
        const professionalCategories = this.props.options.get('professionalCategories');
        if (window.location.pathname !== '/logout') {
            this.props.actions.getOnboardingInformation(accessToken, professionalCategories, () => {
                this.props.preLoaderActions.hidePreLoader();
            });

            this.setState({
                loadedData: true,
            });
        } else {
            this.props.preLoaderActions.hidePreLoader();
        }
    }

    checkToken() {
        this.props.preLoaderActions.showPreLoader();
        const { contractToken } = this.props.match.params;
        const professionalCategories = this.props.options.get('professionalCategories');

        if (window.location.pathname !== '/logout') {
            this.props.actions.getOnboardingInformationByToken(contractToken, professionalCategories, result => {
                this.props.preLoaderActions.hidePreLoader();
                if (result === false) {
                    this.props.goToErrorsView({ errorMessage: ERROR_AL_RECUPERAR_ONBOARDING });
                }
            });

            this.setState({
                loadedData: true,
            });
        } else {
            this.props.preLoaderActions.hidePreLoader();
        }
    }

    render() {
        return <div />;
    }
}

export const ContinueOnboarding = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        options: state.options,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(withFeatureToggling(withRouter(ContinueOnboardingComponent)));
